import { Fragment } from "react";

import { prop, define } from "@/components/builder/utils";
import { useDnDBypassContext } from "@/components/builder/utils/bypass-context";

import BasePreview from "../../../base";

function FormButtonGridPreview({ ...props }) {
  const { data: { value } } = useDnDBypassContext()

  return <BasePreview {...props}>
    <button type="button">
      {value?.label}
    </button>
  </BasePreview>
}

export default define('form-button-grid', FormButtonGridPreview, Fragment)
  .shared(prop.share('FormButtonGrid', 'form-button-grid'))
  .property(prop.predefined.customClass())
  .property(prop.predefined.content().category('standard'))
  .property(...prop.predefined.borders())
  .property(...prop.predefined.appearance())
  .property(...prop.predefined.typography())
  .hideProps(['grid.itemColumn', 'grid.itemRow'])
  .defaultProps({
    background: { color: 'blue-500' },
    textColor: 'gray-100',
    space: {
      padding: 'pt-2 pb-2 pl-3 pr-3',
    },
    size: {
      width: 'w-full',
    },
    border: {
      radius: {
        rounded: "sm",
      },
    },
    cursor: 'cursor-pointer',
  })
  .build()
